import { createContext, useContext } from 'react';

/**
 * Context for programmatically providing a default breakpoint to its children. This is useful for
 * server-side rendering, where there is no window object.
 */ const BreakpointContext = createContext(null);
/**
 * Provider for {@link BreakpointContext}.
 */ const BreakpointProvider = BreakpointContext.Provider;
/**
 * Hook to access the {@link BreakpointContext} value.
 */ const useBreakpointContext = ()=>useContext(BreakpointContext);

export { BreakpointContext, BreakpointProvider, useBreakpointContext };
//# sourceMappingURL=breakpoint-context.js.map
